import { IsiControl } from "../Controls/IsiControl";
import { IsiComponentClientEventArgs } from "./IsiComponentClientEventArgs";
import { IsiComponentAjaxEvent } from "./IsiComponentAjaxEvent";
import { IsiPostbackTransaction } from "./IsiPostbackTransaction";
import { IsiComponentEvent } from "./IsiComponentEvent";
import { IIsiPageController } from "./IIsiPageController";
import { IsiComponentV4 } from "./IsiComponentV4";

//import IsiFwIsiPageRequestManager = require("./IsiFW.IsiPageRequestManager");
//import IsiPageRequestManager = IsiFwIsiPageRequestManager.IsiFW.IsiPageRequestManager;


// Register the namespace for the control.
//Type.registerNamespace('IsiFW');


//
// Define the control properties.
//

export class IsiPageController extends IsiControl implements IIsiPageController {

    registeredObjects: {};
    isFirstLoad: boolean;
    isReady: boolean;


    asyncCallProcessing: boolean;
    currentAsyncCallId: boolean;
    currentAsyncCallBackObject: boolean;
    onEndRequestOk: boolean;
    unload: boolean;
    _postbackTransaction = null;

    constructor(element) {
        super(element);

        //this.registeredObjects;
        this.isFirstLoad = true;
        this.isReady = false;


        this.asyncCallProcessing = false;
        this.currentAsyncCallId = false;
        this.currentAsyncCallBackObject = false;
        this.onEndRequestOk = false;
        this.unload = false;
        this._postbackTransaction = null;

        this.registeredObjects = {};
    }

    initialize() {
        // initialize the base
        super.initialize();

        uiCore.componentManager.registerController(this);

        window.IsiPageControllerExternalInitialization(this);

        if (this.isFirstLoad) {
            this.onLoad();
            this.isFirstLoad = false;
        }

        if (!this.onEndRequestOk) {
            var app = window.Sys.Application;

            window.Sys.WebForms.PageRequestManager.getInstance().add_pageLoaded(function (me) {
                return function (sender, args) {
                    me.onPageLoaded(sender, args);
                }
            }(this));

            app.add_unload(function (me) {
                return function (sender, args) {
                    me.onApplicationUnload(sender, args);
                }
            }(this));

            this.onEndRequestOk = true;
        }
        window.controller = this;
    }
    dispose() {
        // release the handlers
        //$clearHandlers(this.get_element());

        this.registeredObjects = null;

        //this.asyncCallStack = null;
        this.asyncCallProcessing = false;
        this.currentAsyncCallId = false;
        this.currentAsyncCallBackObject = false
        this.onEndRequestOk = false;
        this.unload = false;

        this._postbackTransaction = null;

        // call to the base to do its dispose
        super.dispose();

        //iws_ShowUndisposedProperties("IsiPageController", this);

    }
    getId() {
        return this.get_id();
    }
    get_RegisteredObjects() {
        return this.registeredObjects;
    }
    set_RegisteredObjects(value) {
        this.registeredObjects = value;
    }
    getHiddenDataElement() {
        return jQuery("#pbt", jQuery("#" + this.getId()));
    }
    ready(handler: (sender: IIsiPageController, args: any) => void) {
        if (this.isReady) {
            handler(this, {});
        } else {
            this.get_events().addHandler("ready", handler);
        }
    }
    _onReady(sender, args) {
        var handler = this.get_events().getHandler("ready");
        if (handler) {
            handler(sender, args);
            this.get_events().removeHandler("ready", handler);
        }
        return;
    }
    onLoad() {
        if (!this.isReady) {
            this._onReady(this, {});
            this.isReady = true;
        }
    }
    registerComponent(cp: IsiComponentV4) {
        var me = this;
        var id = cp.getId();
        this.registeredObjects[id] = cp;
        //cp.add_propertyChanged(function (sender, args) { me.onComponentPropertyChanged(sender, args); });
        cp.add_onEvent((sender, args) => {
            this.onComponentEvent(sender, args);
        });
    }
    /*onComponentPropertyChanged (sender, args) {
        var changedProperty = args.get_propertyName();
        var senderId = sender.get_ServerId();
        var newValue = sender["get_" + changedProperty]();
        var data = new Object();
        var dto = sender.get_Dto();

        data.changedProperty = changedProperty
        data.newValue = newValue;

        var eventArgs;
        eventArgs = new IsiComponentClientEventArgs("ComponentPropertyChanged", senderId, "", data, dto);

        var me = this;

        doPostBackAsync(this.getId(), jQuery.toJSON(eventArgs), me.asyncCallBack); //{"sender": sender, "args": args }

        return false;
    }*/
    onComponentEvent(sender, args) {
        var senderId = sender.get_ServerId();
        var eventName = args.eventName;
        var data = args.data;
        var dto = sender._getDtoForServer(eventName);
        var me = this;
        var event: IsiComponentEvent = null;

        var eventArgs;
        let isBlocking;
        isBlocking = args.isBlocking ? args.isBlocking : false;
        if (sender.getSpecificComponentSenderId()) {
            senderId = sender.getSpecificComponentSenderId();
        }

        event = <IsiComponentEvent>sender.getEvent(eventName);

        eventArgs = new IsiComponentClientEventArgs("OnComponentEvent", senderId, eventName, data, dto);

        this.raiseEvent(eventName, eventArgs);

        if (eventArgs.getStopPropagation()) {
            //me.asyncCallBack(null, null, eventArgs, sender, args.callback, args.callbackParams);
            var request = uiCore.pageRequestManager.IsiCreateComponentEventRequest(sender, args, eventArgs, isBlocking);
            this.prepareRequestCallBack(request);
            request.IsiResponse.IsiData = eventArgs;
            uiCore.pageRequestManager.doRequest(request);

        } else {
            if (!this.unload) {
                let request = null;
                //GBAU - 09/03/2020 : le test sur le instanceof ne fonctionne pas tant que tous les composants ne sont pas en TS du fait de l'export sur window
                if (event == null || (event.type() == "PostBack")/*|| !(event instanceof IsiComponentAjaxEvent) !Object.getType(event).inheritsFrom(IsiFW.Components.IsiComponentAjaxEvent)*/) {
                    request = uiCore.pageRequestManager.IsiCreatePostBackRequest(sender, args, eventArgs, isBlocking);
                }
                else if (event != null && (event.type() == "AJAX" || (event instanceof IsiComponentAjaxEvent))/*Object.getType(event).inheritsFrom(IsiFW.Components.IsiComponentAjaxEvent)*/) {
                    let ajaxEvent = <IsiComponentAjaxEvent>event;
                    request = uiCore.pageRequestManager.IsiCreateAjaxRequest(sender, args, eventArgs, ajaxEvent.IsiHTTPMethod, ajaxEvent.IsiUrl, ajaxEvent.IsiQueued, isBlocking);
                }

                if (request != null) {
                    this.prepareRequestCallBack(request);
                    request.IsiResponse.IsiData = eventArgs; //Par défaut, on met comme donnée de réponse l'éventArgs initial

                    uiCore.pageRequestManager.doRequest(request);
                }
            }
        }

        return false;
    }
    addEventHandler(key, handler) {
        this.get_events().addHandler(key, handler);
    }
    removeEventHandler(key, handler) {
        this.get_events().removeHandler(key, handler);
    }
    raiseEvent(key, args) {
        var handler = this.get_events().getHandler(key);
        if (handler) handler(this, args);
        return;
    }
    asyncCallBack(request, args, eventArgs, component, callback, callbackParams) { //TODO : supprimer le param args + coté vb
        //console.log("asyncCallBack = " + eventArgs);
        //console.log(this.asyncCallObjects);
        //GBAU - 14/09/2012 - DYSF51947 : On teste le -1
        if (!request && eventArgs.IsiRequestId) {
            request = uiCore.pageRequestManager.getRequest(eventArgs.IsiRequestId);
            //LRAT this.asyncCallObjects[eventArgs.IsiAsyncCallId].eventArgs = eventArgs;
            request.IsiResponse.IsiData = eventArgs;
        }

        if (component != undefined) {
            component._asyncCallBack(request.IsiResponse.IsiData, callback, callbackParams);
        }
    }
    onPageLoaded(sender, args) {
        //console.log("onPageLoaded");
    }
    onApplicationUnload(sender, args) {
        uiCore.pageRequestManager.onApplicationUnload(sender, args);
    }
    openPostbackTransaction() {
        this._postbackTransaction = new IsiPostbackTransaction();
    }
    commitPostbackTransaction(send) {
        (send == undefined) ? send = true : send;
        if (!send) {
            this.getHiddenDataElement().val(jQuery.toJSON(this._postbackTransaction));
        }
    }
    prepareRequestCallBack(request) {
        var callback;
        var initialCallback;
        var initialCallbackParams;
        if (request.IsiCallback.data == undefined) {
            request.IsiCallback.data = null;
        }

        if (request.IsiCallback.callback == undefined) {
            request.IsiCallback.callback = null;
        }

        if (request.IsiCallback.callbackParams == undefined) {
            request.IsiCallback.callbackParams = null;
        }

        //29/06/2016 - DEV123704 : Ajout d'un callback en cas d'erreur
        if (typeof (request.IsiErrorCallback) === 'undefined') {
            request.IsiErrorCallback = {}
        }
        if (typeof (request.IsiErrorCallback.callback) === 'undefined') {
            request.IsiErrorCallback.callback = null;
        }

        if (typeof (request.IsiErrorCallbackParams) === 'undefined') {
            request.IsiErrorCallback.callbackParams = null;
        }

        initialCallback = request.IsiCallback.callback;
        initialCallbackParams = request.IsiCallback.callbackParams;
        callback = function (me, initialCallback, initialCallbackParams) {
            return function () {
                me.asyncCallBack(request, null, null, request.IsiSender, initialCallback, initialCallbackParams);
            }
        }(this, initialCallback, initialCallbackParams);
        request.IsiCallback.callback = callback;
        request.IsiCallback.callbackParams = null;

        //29/06/2016 - DEV123704 : Ajout d'un callback en cas d'erreur
        initialCallback = request.IsiErrorCallback.callback;
        initialCallbackParams = request.IsiErrorCallback.callbackParams;
        callback = function (me, initialCallback, initialCallbackParams) {
            return function () {
                me.asyncCallBack(request, null, null, request.IsiSender, initialCallback, initialCallbackParams);
            }
        }(this, initialCallback, initialCallbackParams);
        request.IsiErrorCallback.callback = callback;
        request.IsiErrorCallback.callbackParams = null;

        return true;
    }
    /**
     * Indique si le composant gère un état coté client (localStorage)
     * @returns boolean
     */
    useClientState() {
        return false;
    }

    static IsiCreate = function (id, container, properties, element) {
        /// <summary>
        /// Cette fonction permet de créer le composant coté client (balise html + objet JS)
        /// </summary>
        /// <history>
        ///		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        /// <history>
        var jElement;
        var object;

        jElement = IsiPageController.IsiCreateElement(id, container, properties, element);
        if (properties.Index != undefined) {
            properties.Index = undefined;
            delete properties.Index;
        }
        object = IsiPageController.IsiCreateObject(id, properties, jElement);

        return object;
    }

    static IsiCreateElement = function (id, container, pProps, element) {
        /// <summary>
        /// Cette fonction permet de créer la partie html du composant coté client
        /// </summary>
        /// <history>
        ///		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        /// <history>

        var jRoot;
        var jValue;

        if (typeof (element) == 'undefined') {
            jRoot = jQuery('<div></div>');
            jRoot.attr("id", id);
        } else {
            jRoot = jQuery(element);
        }

        jRoot.addClass("IsiPageController");
        jRoot.attr("tp", "1");

        if (container) {
            jQuery(container).append(jRoot);
        }

        return jRoot;
    }

    static IsiCreateObject = function (id, properties, jElement) {
        /// <summary>
        /// Cette fonction permet de créer l'objet JS du composant coté client
        /// </summary>
        /// <history>
        ///		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        /// <history>
        var object;
        var element;
        element = jElement[0];

        //Instanciation de l'objet IsiTouchPad
        object = new IsiPageController(element);
        for (var i in properties) {
            object["set_" + i](properties[i]);
        }
        object.initialize();
        //object = $create((IsiTouchPad) as any, properties, null, null, element);

        return object;
    }
}

/*
Function.emptyMethod = function (args) {

};
*/

//IsiFW.IsiPageController.registerClass("IsiFW.IsiPageController", Sys.UI.Control);
//if (typeof (Sys) !== 'undefined') Sys.Application.notifyScriptLoaded();
